import React from 'react';
import PageHero from '../components/PageHero';
import HowItWorks from '../components/HowItWorks';
import RevealOnScroll from '../components/RevealOnScroll';
import FinalCTA from '../components/FinalCTA';

const HowItWorksPage: React.FC = () => {
  return (
    <>
      <PageHero
        title="How OTL Express Ships Your Packages"
        subtitle="Step-by-step guide to shopping in Sri Lanka and shipping to the Maldives."
      />

      <section className="bg-slate-50 pt-16 -mb-24 relative z-10">
        <div className="max-w-5xl mx-auto px-4">
          <RevealOnScroll>
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white bg-black">
              <video
                controls
                poster="https://otl.nyc3.cdn.digitaloceanspaces.com/otlexp.com%20-%20FE/Step%204.jpg"
                className="w-full aspect-video"
              >
                <source src="https://otl.nyc3.cdn.digitaloceanspaces.com/otlexp.com%20-%20FE/OTL_1080P.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </RevealOnScroll>
        </div>
      </section>

      {/* Reuse the component but it will now appear below the video */}
      <div className="pt-24">
        <HowItWorks />
      </div>
      <FinalCTA />
    </>
  );
};

export default HowItWorksPage;